import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps, Checkbox, TableCell } from '@mui/material';
import { TableSelectableColumnHeader } from '../constants.js';
import TableContext from '../TableContext.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _excluded = ["deselected", "allSelected"];
var componentRoot = createComponentSlot({
  name: "CinTableSelectableColumn",
  slot: "Root"
});

var SelectableColumnBase = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectableColumnBase, _React$Component);

  var _super = _createSuper(SelectableColumnBase);

  function SelectableColumnBase() {
    var _this;

    _classCallCheck(this, SelectableColumnBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_keyWarning", false);

    _defineProperty(_assertThisInitialized(_this), "getItemKey", function (item) {
      var _this$context$dataKey = _this.context.dataKey,
          dataKey = _this$context$dataKey === void 0 ? "key" : _this$context$dataKey;
      var key = item ? item[dataKey] : undefined;

      if (!key && !_this._keyWarning) {
        console.error("Table dataKey is invalid");
        _this._keyWarning = true;
      }

      return key;
    });

    _defineProperty(_assertThisInitialized(_this), "getHeaderType", function () {
      var _this$props$header;

      return (_this$props$header = _this.props.header) !== null && _this$props$header !== void 0 ? _this$props$header : TableSelectableColumnHeader.Page;
    });

    _defineProperty(_assertThisInitialized(_this), "allItemsForEveryPageSelected", function () {
      var _value$selected, _value$deselected;

      var data = _this.context.data;
      if (!data) return false;
      var _this$props = _this.props,
          value = _this$props.value,
          totalItems = _this$props.totalItems;
      var selected = (_value$selected = value.selected) !== null && _value$selected !== void 0 ? _value$selected : [];
      var deselected = (_value$deselected = value.deselected) !== null && _value$deselected !== void 0 ? _value$deselected : [];
      return (// selecting all + no deselected
        value.allSelected && deselected.length === 0 || // not selecting all + everything selected
        !value.allSelected && selected.length === totalItems
      );
    });

    _defineProperty(_assertThisInitialized(_this), "allItemsForCurrentPageSelected", function () {
      var _value$selected2, _value$deselected2;

      var data = _this.context.data;
      if (!data) return false;
      var value = _this.props.value;
      var pageKeys = data.map(function (i) {
        return _this.getItemKey(i);
      });
      var selected = (_value$selected2 = value.selected) !== null && _value$selected2 !== void 0 ? _value$selected2 : [];
      var deselected = (_value$deselected2 = value.deselected) !== null && _value$deselected2 !== void 0 ? _value$deselected2 : [];
      return (// selecting all + nothing on current page in deselected
        value.allSelected && pageKeys.every(function (k) {
          return deselected.indexOf(k) < 0;
        }) || // not selecting all + everything on current page in selected
        !value.allSelected && pageKeys.every(function (k) {
          return selected.indexOf(k) >= 0;
        })
      );
    });

    _defineProperty(_assertThisInitialized(_this), "someItemsForAnyPageSelected", function () {
      var _value$selected3, _value$deselected3;

      var data = _this.context.data;
      if (!data) return false;
      var _this$props2 = _this.props,
          value = _this$props2.value,
          totalItems = _this$props2.totalItems;
      var selected = (_value$selected3 = value.selected) !== null && _value$selected3 !== void 0 ? _value$selected3 : [];
      var deselected = (_value$deselected3 = value.deselected) !== null && _value$deselected3 !== void 0 ? _value$deselected3 : [];
      return (// selecting all + not everything in deselected
        value.allSelected && deselected.length < totalItems || // not selecting all + something in selected
        !value.allSelected && selected.length > 0
      );
    });

    _defineProperty(_assertThisInitialized(_this), "someItemsForCurrentPageSelected", function () {
      var _value$selected4, _value$deselected4;

      var data = _this.context.data;
      if (!data) return false;
      var value = _this.props.value;
      var pageKeys = data.map(function (i) {
        return _this.getItemKey(i);
      });
      var selected = (_value$selected4 = value.selected) !== null && _value$selected4 !== void 0 ? _value$selected4 : [];
      var deselected = (_value$deselected4 = value.deselected) !== null && _value$deselected4 !== void 0 ? _value$deselected4 : [];
      return (// selecting all + not everything on current page in deselected
        value.allSelected && pageKeys.some(function (k) {
          return deselected.indexOf(k) < 0;
        }) || // not selecting all + something on current page in selected
        !value.allSelected && pageKeys.some(function (k) {
          return selected.indexOf(k) >= 0;
        })
      );
    });

    _defineProperty(_assertThisInitialized(_this), "getHeaderState", function () {
      var _this$context$data;

      var canSelectAll = _this.props.canSelectAll;

      var headerType = _this.getHeaderType();

      var allSelected = false;
      var someSelected = false;

      if (headerType === TableSelectableColumnHeader.All) {
        // select all items
        allSelected = _this.allItemsForEveryPageSelected();
        someSelected = _this.someItemsForAnyPageSelected();
      } else if (headerType === TableSelectableColumnHeader.Page) {
        // select current page only
        allSelected = _this.allItemsForCurrentPageSelected();
        someSelected = _this.someItemsForCurrentPageSelected();
      }

      var selectable = canSelectAll ? canSelectAll((_this$context$data = _this.context.data) !== null && _this$context$data !== void 0 ? _this$context$data : []) : true;
      var result = {
        disabled: !selectable,
        checked: false,
        indeterminate: false
      };

      if (allSelected && someSelected) {
        result.checked = true;
      } else if (someSelected) {
        result.indeterminate = true;
      } else {
        result.checked = false;
      }

      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "onHeaderSelect", function (event, checked) {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          onChange = _this$props3.onChange,
          canSelect = _this$props3.canSelect;

      var headerType = _this.getHeaderType();

      if (headerType === TableSelectableColumnHeader.All) {
        // select all items
        // cannot account for canSelect as would not be known if items on hidden pages are selectable
        onChange(_objectSpread2(_objectSpread2({}, value), {}, {
          allSelected: checked,
          selected: [],
          deselected: []
        }));
      } else if (headerType === TableSelectableColumnHeader.Page) {
        var _this$context$data2, _value$selected5;

        // select current page only
        var pageKeys = ((_this$context$data2 = _this.context.data) !== null && _this$context$data2 !== void 0 ? _this$context$data2 : []).filter(function (i, idx) {
          return canSelect ? canSelect(i, idx) : true;
        }).map(function (i) {
          return _this.getItemKey(i);
        });
        var selected = (_value$selected5 = value.selected) !== null && _value$selected5 !== void 0 ? _value$selected5 : [];
        var selectedPageKeys = pageKeys.filter(function (k) {
          return selected.indexOf(k) >= 0;
        });
        var selectingAll = selectedPageKeys.length < pageKeys.length;
        var togglePageKeys = selectingAll ? // toggle deselected items on current page
        pageKeys.filter(function (k) {
          return selectedPageKeys.indexOf(k) < 0;
        }) : // toggle selected items on current page
        selectedPageKeys;

        var newValue = _this.toggleItems(togglePageKeys, selectingAll);

        onChange(newValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getItemState", function () {
      var _this$props4 = _this.props,
          value = _this$props4.value,
          canSelect = _this$props4.canSelect;
      var _this$context = _this.context,
          item = _this$context.item,
          itemIndex = _this$context.itemIndex;
      if (!item) return {
        disabled: false,
        checked: false
      };
      var selectable = canSelect ? canSelect(item, itemIndex !== null && itemIndex !== void 0 ? itemIndex : -1) : true;

      var itemKey = _this.getItemKey(item);

      if (value.selected && ~value.selected.indexOf(itemKey)) {
        return {
          disabled: !selectable,
          checked: true
        };
      }

      return {
        disabled: !selectable,
        checked: !!value.allSelected && (!value.deselected || !~value.deselected.indexOf(itemKey))
      };
    });

    _defineProperty(_assertThisInitialized(_this), "toggleItems", function (itemKeyArray, checked) {
      var _this$props5 = _this.props,
          value = _this$props5.value,
          totalItems = _this$props5.totalItems;

      var headerType = _this.getHeaderType();

      var sel = _objectSpread2(_objectSpread2({}, value), {}, {
        selected: value.selected ? _toConsumableArray(value.selected) : [],
        deselected: value.deselected ? _toConsumableArray(value.deselected) : []
      });

      itemKeyArray.forEach(function (itemKey) {
        // if item is deselected, remove it.
        // if item is selected, remove it.
        var di = sel.deselected.indexOf(itemKey);
        if (~di) sel.deselected.splice(di, 1);
        var si = sel.selected.indexOf(itemKey);
        if (~si) sel.selected.splice(si, 1);

        if (checked === true && !sel.allSelected) {
          sel.selected.push(itemKey);
        }

        if (checked === false && sel.allSelected) {
          sel.deselected.push(itemKey);
        }
      });

      if (headerType !== TableSelectableColumnHeader.All) {
        // deselected + allSelected not used in this mode
        sel.deselected;
            sel.allSelected;
            var rest = _objectWithoutProperties(sel, _excluded);

        return rest;
      }

      if (sel.allSelected && sel.deselected.length == totalItems) {
        sel.allSelected = false;
        sel.deselected = [];
      }

      if (!sel.allSelected && sel.selected.length == totalItems) {
        sel.allSelected = true;
        sel.selected = [];
      }

      return sel;
    });

    _defineProperty(_assertThisInitialized(_this), "onItemSelect", function (event, checked) {
      event.stopPropagation();

      var itemKey = _this.getItemKey(_this.context.item);

      var newValue = _this.toggleItems([itemKey], checked);

      return _this.props.onChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onCellClick", function (e) {
      return e.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "defaultHeaderRender", function (state, events) {
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, state, events));
    });

    _defineProperty(_assertThisInitialized(_this), "defaultItemRender", function (item, state, events) {
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, state, events));
    });

    return _this;
  }

  _createClass(SelectableColumnBase, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          renderHeader = _this$props6.renderHeader,
          renderItem = _this$props6.renderItem,
          align = _this$props6.align,
          className = _this$props6.className;
      var _this$context2 = this.context,
          item = _this$context2.item,
          headerRow = _this$context2.headerRow,
          footerRow = _this$context2.footerRow;

      if (headerRow) {
        // render header cell
        var headerType = this.getHeaderType();
        var headerState = this.getHeaderState();
        var headerEvents = {
          onChange: this.onHeaderSelect
        };
        var headerRender = renderHeader !== null && renderHeader !== void 0 ? renderHeader : this.defaultHeaderRender;
        return /*#__PURE__*/React.createElement(TableCell, {
          align: align,
          className: classnames(componentRoot.className, className)
        }, headerType !== TableSelectableColumnHeader.Hide && headerRender(headerState, headerEvents));
      }

      if (footerRow) {
        // render footer cell - not currently supported
        return /*#__PURE__*/React.createElement(TableCell, {
          align: align,
          className: classnames(componentRoot.className, className)
        });
      }

      var itemState = this.getItemState();
      var itemEvents = {
        onChange: this.onItemSelect
      };
      var itemRender = renderItem !== null && renderItem !== void 0 ? renderItem : this.defaultItemRender; // render data cell

      return /*#__PURE__*/React.createElement(TableCell, {
        align: align,
        className: classnames(componentRoot.className, className),
        onClick: this.onCellClick
      }, item && itemRender(item, itemState, itemEvents));
    }
  }]);

  return SelectableColumnBase;
}(React.Component);

_defineProperty(SelectableColumnBase, "propTypes", {
  value: propTypes.any.isRequired,
  onChange: propTypes.func.isRequired,
  totalItems: propTypes.number.isRequired,
  canSelect: propTypes.func,
  canSelectAll: propTypes.func,
  header: propTypes.any,
  renderHeader: propTypes.func,
  renderItem: propTypes.func,
  width: propTypes.oneOfType([propTypes.string, propTypes.number]),
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
});

_defineProperty(SelectableColumnBase, "contextType", TableContext);

var SelectableColumnRoot = styled(SelectableColumnBase, componentRoot.styledOptions)(function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 56 : _ref$width;
  return {
    // evenly divide the default padding on table cells/checkboxes to preserve the default spacing
    padding: 8,
    ".MuiCheckbox-root": {
      padding: 8
    },
    "&.MuiTableCell-head": {
      width: width
    }
  };
});
/**
 * Renders a column with checkboxes for selecting items
 */

var SelectableColumn = function SelectableColumn(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(SelectableColumnRoot, rootProps);
};

var SelectableColumn$1 = SelectableColumn;

export { SelectableColumn$1 as default };
